export class BoardError extends Error {
  constructor(msg) {
    super()
    this.message = msg
    this.name = 'Board Error'
  }
}



// WEBPACK FOOTER //
// ./src/chessEngine/chess_engine_custom_errors.js